<template>
  <v-card class="pa-3" outlined style="border-radius: 6px; height: 100%">
    <div class="pa-2 grey lighten-2" style="border-radius: 6px">
      <strong>{{ $t('Resolutividade Últimos 30 dias') }}</strong>
    </div>

    <div style="position: relative">
      <h1
        style="
          position: absolute;
          top: 53%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
      >
        {{ data.percentage ? data.percentage.toFixed(2) : '0.00' }}%
      </h1>
      <DoughnutChart :chart-data="chartData" :options="options" />
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import DoughnutChart from '../../Reports/components/charts/doughnutChart'

export default {
  name: 'ResolvabilityComponent',

  props: {
    unidadeIds: Array,
    departmentIds: Array,
    institutionIds: Array,
  },

  watch: {
    unidadeIds() {
      this.filter.unidadeIds = this.unidadeIds
    },
    departmentIds() {
      this.filter.departmentIds = this.departmentIds
    },
    institutionIds() {
      this.filter.institutionIds = this.institutionIds
    },
  },

  components: {
    DoughnutChart,
  },

  data() {
    return {
      options: {},
      apiService: new ApiService(),
      filter: {
        page: 1,
        pageSize: 10,
        unidadeIds: [],
        departmentIds: [],
        institutionIds: [],
        institutionId: 1,
      },
      chartData: {},
      data: {
        dataByMonth: [],
      },
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    list() {
      this.apiService
        .post('dash/resolvability', this.filter)
        .then((response) => {
          this.data = response.content
          this.chartData = {
            labels: ['Externas', 'Internas'],
            datasets: [
              {
                label: 'Execução total',
                data: [100 - this.data.percentage, this.data.percentage],
                backgroundColor: ['#0288d1', '#bbcf20'],
                pointRadius: 5,
                pointHoverRadius: 10,
              },
            ],
          }
        })
    },
  },
}
</script>

<style scoped></style>
